import { Grid, Tabs, Typography, Tab, Divider } from '@material-ui/core'

import React, { useState } from 'react'

// import { connect } from 'react-redux'

const MatchMakeMeTabsInfo = ({
    tabClickedCallback,
    matchMakeMeCount,
    loader,
    userName,
    tabInitialValue,
    setTabInitialValue,
    counts,
}) => {
    const handleChange = (event, newValue) => {
        setTabInitialValue(newValue)
        if (newValue !== tabInitialValue) {
            tabClickedCallback()
        }
    }
    const routes = [
        {
            title: `MatchMakeMe (${
                matchMakeMeCount >= 100 ? '100+' : matchMakeMeCount
            })`,
            value: 'MATCHMAKEME',
        },
        {
            title: `${userName}'s likes (${counts?.liker})`,
            value: 'LIKER',
        },

        {
            title: `Who liked ${userName} (${counts?.liked})`,
            value: 'LIKED',
        },
        {
            title: `${userName}'s dislikes (${counts?.disliker})`,
            value: 'DISLIKER',
        },

        {
            title: ` Who disliked ${userName} (${counts?.disliked})`,
            value: 'DISLIKED',
        },
        {
            title: ` ${userName}'s Matches (${counts?.matches})`,
            value: 'MATCHES',
        },
    ]

    return (
        <Grid container alignItems="flex-start">
            {/* ------------------------------------------------------------------------------------------tab section */}
            <Grid
                item
                justifyContent="space-between"
                alignItems="center"
                style={{
                    height: 48,
                    marginTop: 30,
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <Grid item>
                    <Tabs
                        value={tabInitialValue}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        style={{ flex: 1 }}
                    >
                        {routes.map((item, i) => (
                            <Tab
                                disabled={loader}
                                key={i}
                                classes={{ wrapper: 'tabsIndicator' }}
                                label={item.title}
                                value={item.value}
                                style={{
                                    fontSize: 16,
                                    textTransform: 'unset',
                                    fontFamily: 'interSemi',
                                    minWidth: 80,
                                    marginRight: 50,
                                    paddingRight: 0,
                                    paddingLeft: 0,
                                }}
                            />
                        ))}
                    </Tabs>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
        </Grid>
    )
}

export default MatchMakeMeTabsInfo
